// Жеребьёвка: распределение команд по группам, с учётом сеяных.

// Тасование Фишера-Йетса
export const shuffle = (items) => {
  const result = [...items];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
};

// Сеяные команды разводятся по разным группам: пока их не больше числа групп,
// в одной группе не окажется двух сеяных. Несеяные потом добираются так,
// чтобы размеры групп отличались максимум на единицу.
export const drawTeams = (teams, groups, seededIds = []) => {
  const order = [];
  const assignment = {};
  if (!groups.length || !teams.length) return { order, assignment };

  const seededSet = new Set(seededIds.map(Number));
  const seeded = shuffle(teams.filter(t => seededSet.has(Number(t.team_id))));
  const rest = shuffle(teams.filter(t => !seededSet.has(Number(t.team_id))));

  const counts = groups.map(() => 0);
  const place = (team, groupIndex, pot) => {
    const group = groups[groupIndex];
    // Массив: одна команда может быть в нескольких группах (жеребьёвка даёт одну).
    assignment[team.team_id] = [group.id];
    order.push({
      team,
      groupId: group.id,
      groupIndex,
      slotIndex: counts[groupIndex],
      pot,
    });
    counts[groupIndex] += 1;
  };

  // Сеяных раскладываем по кругу — по одной в группу, потом по второй и так далее.
  // Стартовую группу выбираем случайно, иначе первая всегда получала бы
  // первую вытянутую команду.
  const offset = Math.floor(Math.random() * groups.length);
  seeded.forEach((team, index) => {
    place(team, (offset + index) % groups.length, 'seeded');
  });

  // Несеяных кладём каждый раз в самую пустую группу
  rest.forEach(team => {
    let target = 0;
    for (let i = 1; i < counts.length; i++) {
      if (counts[i] < counts[target]) target = i;
    }
    place(team, target, 'rest');
  });

  return { order, assignment };
};

// Сколько команд окажется в каждой группе — для подсказки перед жеребьёвкой
export const groupSizes = (teamCount, groupCount) => {
  if (!groupCount) return [];
  const base = Math.floor(teamCount / groupCount);
  const extra = teamCount % groupCount;
  return Array.from({ length: groupCount }, (_, i) => base + (i < extra ? 1 : 0));
};

// Предупреждения по сеяным. Ошибок тут нет — жеребьёвку это не блокирует,
// но админ должен понимать, что получится.
export const seedingWarnings = (teamCount, groupCount, seededCount) => {
  const warnings = [];
  if (seededCount === 0 || groupCount === 0) return warnings;

  if (seededCount > groupCount) {
    const perGroup = Math.ceil(seededCount / groupCount);
    warnings.push(
      `Сеяных больше, чем групп (${seededCount} на ${groupCount}). ` +
      `Развести их по разным группам не получится — в отдельных группах ` +
      `окажется до ${perGroup} сеяных.`
    );
  }
  if (seededCount * 2 > teamCount) {
    warnings.push(
      `Сеяных больше половины состава (${seededCount} из ${teamCount}). ` +
      `Обычно сеяных делают не больше, чем групп.`
    );
  }
  return warnings;
};
